// extracted by mini-css-extract-plugin
export var form = "_f5-0";